import { render, staticRenderFns } from "./OrderDraftHeader.vue?vue&type=template&id=24153c8c&"
import script from "./OrderDraftHeader.vue?vue&type=script&lang=js&"
export * from "./OrderDraftHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports